import { Body1, ButtonNextLink, Card, H2, Stack, screen } from '@tumelo/designsystem'
import { ErrorBoundaryWithLogger } from '@tumelo/logging'
import Image from 'next/image'
import React from 'react'
import styled from 'styled-components'
import { LayoutContentOverHeader } from '@/components/Layout'

export const PageErrorBoundary: React.FC<React.PropsWithChildren> = ({ children }) => (
  <ErrorBoundaryWithLogger fallback={<ErrorPage />}>{children}</ErrorBoundaryWithLogger>
)

const ErrorPage: React.FC = () => {
  return (
    <LayoutContentOverHeader pageH1="Something went wrong">
      <Card variant="shadow" mb="2.4rem">
        <H2>Unexpected error</H2>
        <StyledImage width={0} height={0} src="/images/tumole.png" alt="Mole character looking confused" />
        <Body1 mb="0">
          Something went wrong while trying to load this page. It might be a temporary glitch or an issue on our end.
          Please try refreshing the page or come back a little later.
        </Body1>
        <StyledButtons>
          <ButtonNextLink variant="secondary" href="/help">
            Help page
          </ButtonNextLink>
          <ButtonNextLink href="/my-account">Back to homepage</ButtonNextLink>
        </StyledButtons>
      </Card>
    </LayoutContentOverHeader>
  )
}

const StyledImage = styled(Image)`
  width: 100%;
  height: auto;
  margin-bottom: 2.4rem;
`
const StyledButtons = styled(Stack)`
  width: 100%;
  span {
    width: 100%;
  }
  bottom: 0;
  left: 0;
  margin-top: 3.2rem;

  @media ${screen.mediumUp} {
    margin-top: 4rem;
    flex-direction: row;
    button {
      width: 50%;
    }
    button,
    a {
      width: 50%;
    }
  }
`
